//
// export type Nullable<T> = T | null;
//
// export const ActionTypeSchema = z.object({
//   Id: z.number(),
//   ActionNameAr: z.string(),
//   ActionNameEn: z.string(),
// });
//
// export const ApplicationSchema = z.object({
//   Id: z.number(),
//   ApplicationNameAr: z.string(),
//   ApplicationNameEn: z.string(),
//   ApplicationDomainId: z.number(),
//   Visible: z.boolean(),
//   ActionType: ActionTypeSchema,
//   Company: CompanySchema,
//   RequiredDocuments: z.array(DocumentSchema),
//   Value: z.string(),
// });
//
// export type ActionType = z.infer<typeof ActionTypeSchema>;
// export type Application = z.infer<typeof ApplicationSchema>;

import { z } from "zod";

const AcknowledgementDetailsSchema = z.object({
  ApplicationActionId: z.number().optional(),
  AcknowledgementName: z.string().optional(),
  AcknowledgementDescEn: z.string().optional(),
  AcknowledgementDescAr: z.string().optional(),
});

export type AcknowledgementDetails = z.infer<
  typeof AcknowledgementDetailsSchema
>;
export interface AcknowledgementsResponse {
  Data: AcknowledgementDetails[];
  Code: number;
  Success: boolean;
  Message: string[];
}
export interface AcknowledgementsParams {
  EmpId: number;
  ApplicationId: number;
  ActionId: number;
}

export interface AcknowledgementsPayload {}
